import {
  Button,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
} from '@material-ui/core';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { FormControl } from '@mui/material';
import moment from 'moment';
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  DASHBOARD_BILL_VIEW,
  DASHBOARD_IRD_VIEW,
  FNB_BILL_STATUS,
  FNB_ORDERS,
  FNB_STATUS,
  IRD_FILTER,
  IRD_STATUS,
  FNB_FILTER,
} from '../../../../constants/DashboardConst';
import { RBAC_PERMISSION_LEVEL_FULL_ACCESS } from '../../../../constants/RoleConsts';
import CustomCountBox from '../../../../shared/custom-count-box/Custom-Count-Box';
import LinearProgressBar from '../../../../shared/progress-bar/Progress';
import SearchBar from '../../../../shared/search-bar/Search-Bar';
import TablePaginationActions from '../../../../shared/table-pagination/TablePaginationActions';
import { getTimeDifference } from '../../../../utils/commonUtils';
import { getAccessControl } from '../../../../utils/RBACUtil';
import {
  allRestaurantSelector,
  dashboardSelectedRestaurantSelector,
  selectedHotelCurrencySelector,
  selectedHotelSelector,
  setDashboardSelectedRestaurant,
} from '../../../property/propertySlice';
import {
  dashboardFnbBillsListSelector,
  dashboardFnbCountSelector,
  dashboardFnbIrdModeSelector,
  dashboardFnbListSelector,
  dashboardFnbLoadingSelector,
  dashboardIrdCountSelector,
  dashboardIrdListSelector,
  fetchAllDashboardFnbList,
  fetchAllDashboardIrdList,
  getRestaurantId,
  setDashBoardFnbIrdMode,
  setRestaurantId,
} from '../../DashboardSlice';
import './DashboardFnbList.scss';
import { generatedElapsedTime } from '../../../../utils/dashboardUtils';
import { checkAuthState } from '../../../../utils/APIUtils';

const DashboardFnbList = (props) => {
  const history = useHistory();
  const {
    onViewToggle,
    page,
    rowsPerPage,
    onsetRowsPerPage,
    onsetPage,
    billMode,
    currentFilterFromLocation,
  } = props;
  const [filterDataList, setFilterDataList] = useState([]);
  const [dashboardFnbOrders, setDashboardFnbOrders] = useState([]);
  const [originalList, setOriginalList] = useState([]);
  const [loading, setLoading] = useState(true);
  const dashboardFnbCount = useSelector(dashboardFnbCountSelector);
  const [tempSearchText, setTempSearchText] = useState('');
  const originalRestList = useSelector(allRestaurantSelector);
  const dashboardFnbLoading = useSelector(dashboardFnbLoadingSelector);
  const dashboardIrdMode = useSelector(dashboardFnbIrdModeSelector);
  const allDashboardFnbList = useSelector(dashboardFnbListSelector);
  const [selectedRestaurant, setRestaurant] = useState(null);
  const selectedHotel = useSelector(selectedHotelSelector);
  const allDashboardIRDList = useSelector(dashboardIrdListSelector);
  const allDashboardBillsList = useSelector(dashboardFnbBillsListSelector);
  const [billsList, setBillsList] = useState([]);
  const [filteredBaseList, setFilteredBaseList] = useState([]);
  const dashboardIrdCount = useSelector(dashboardIrdCountSelector);
  const [billRequestNoficication, setBillRequestNoficication] = useState(false);
  const [billListMode, setBillListMode] = useState(billMode);
  const [isCulinaryOperationManager, setIsCulinaryOperationManager] = useState(false);
  const [isFnBAgent, setIsFnBAgent] = useState(false);
  const currency = useSelector(selectedHotelCurrencySelector);
  const restaurantId = useSelector(getRestaurantId);

  const dispatch = useDispatch();
  const prevHotelRef = useRef(selectedHotel);

  useEffect(() => {
    if (!restaurantId && !dashboardIrdMode) {
      dispatch(setDashBoardFnbIrdMode(true));
      dispatch(fetchAllDashboardIrdList(selectedHotel));
    } else if (dashboardIrdMode) {
      dispatch(fetchAllDashboardIrdList(selectedHotel));
    } else if (restaurantId) {
      dispatch(setDashBoardFnbIrdMode(false));
      dispatch(fetchAllDashboardFnbList(selectedHotel, restaurantId));
    }
  }, [dashboardIrdMode, restaurantId, selectedHotel]);

  useEffect(() => {
    const r = originalRestList?.find((r) => r?.id === restaurantId) || null;
    setRestaurant(r);
  }, [restaurantId, originalRestList]);

  useEffect(() => {
    const ordersList = dashboardIrdMode ? allDashboardIRDList : allDashboardFnbList;
    setOriginalList(ordersList);
    setDashboardFnbOrders(sortList(ordersList));
    setFilteredBaseList(sortList(ordersList));
    setLoading(false);
    setTempSearchText('');
    setBillRequestNoficication(
      ordersList.filter((item) => item.status === 'BILL_REQUESTED').length > 0,
    );
  }, [dashboardIrdMode, allDashboardIRDList, allDashboardFnbList]);

  useEffect(() => {
    if (restaurantId) {
      dispatch(setDashBoardFnbIrdMode(false));
      dispatch(fetchAllDashboardFnbList(selectedHotel, restaurantId));
    }
  }, [restaurantId]);

  useEffect(() => {
    if (prevHotelRef.current !== selectedHotel) {
      dispatch(setRestaurantId(''));
      dispatch(setDashBoardFnbIrdMode(true));
      dispatch(fetchAllDashboardIrdList(selectedHotel));
      prevHotelRef.current = selectedHotel;
    }
  }, [selectedHotel]);

  useEffect(() => {
    const accessControl = async () => {
      try {
        const perms = await getAccessControl();
        if (perms.inRoomDiningDashboard === RBAC_PERMISSION_LEVEL_FULL_ACCESS) {
          if (!dashboardIrdMode) {
            dispatch(fetchAllDashboardFnbList(selectedHotel, selectedRestaurant?.id));
          }
        }
      } catch (e) {
        console.error(e);
      }
    };
    accessControl();
  }, []);

  useEffect(() => {
    const userRole = async () => {
      const currUser = await checkAuthState();
      if (
        currUser &&
        currUser?.attributes &&
        currUser?.attributes['custom:role'] === 'CULINARY_OPERATIONS_MANAGER'
      ) {
        setIsCulinaryOperationManager(true);
      }

      if (currUser && currUser?.attributes && currUser?.attributes['custom:role'] === 'FnB_AGENT') {
        setIsFnBAgent(true);
      }
    };
    userRole();
  }, []);

  useEffect(() => {
    if (isFnBAgent && originalRestList?.length > 0 && !restaurantId) {
      dispatch(setRestaurantId(originalRestList[0].id));
      dispatch(setDashBoardFnbIrdMode(false));
    }
  }, [isFnBAgent, originalRestList]);

  const handleChangePage = (event, newPage) => {
    onsetPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    onsetRowsPerPage(parseInt(event.target.value, 10));
    onsetPage(0);
  };

  const onViewDetails = (view, order) => {
    onViewToggle(view, true, order);
  };

  useEffect(() => {
    setLoading(dashboardFnbLoading);
  }, [dashboardFnbLoading]);

  useEffect(() => {
    setBillsList(allDashboardBillsList);
  }, [allDashboardBillsList]);

  useEffect(() => {
    const updatedFilter = [...IRD_FILTER];
    updatedFilter[1].subMenu = billListMode
      ? FNB_BILL_STATUS
      : dashboardIrdMode
      ? IRD_STATUS
      : FNB_STATUS;

    updatedFilter[1].subMenu.forEach((elm) => {
      elm.selected = false;
      return elm;
    });
    setFilterDataList(updatedFilter);
  }, [dashboardIrdMode, billListMode]);

  useEffect(() => {
    setTempSearchText('');
    if (!currentFilterFromLocation) {
      const ordersList = dashboardIrdMode ? allDashboardIRDList : allDashboardFnbList;
      setDashboardFnbOrders(sortList(ordersList));
    }
    if (currentFilterFromLocation) {
      const updatedFilter = [...IRD_FILTER];
      let subFilter = billListMode
        ? [...FNB_BILL_STATUS]
        : dashboardIrdMode
        ? [...IRD_STATUS]
        : [...FNB_STATUS];
      let STATUS = billListMode ? FNB_BILL_STATUS : dashboardIrdMode ? IRD_STATUS : FNB_STATUS;
      switch (currentFilterFromLocation) {
        case 'TOTAL':
          subFilter = STATUS.map((x) => {
            return { ...x, selected: false };
          });
          setBillListMode(false);
          break;
        case 'NEW_ORDER':
          subFilter = STATUS.map((x) => {
            return { ...x, selected: x.id === 'New Order' };
          });
          setBillListMode(false);
          break;
        case 'PREPARING':
          subFilter = STATUS.map((x) => {
            return { ...x, selected: x.id === 'Preparing' };
          });
          setBillListMode(false);
          break;

        case 'DELIVERED':
          subFilter = STATUS.map((x) => {
            return { ...x, selected: x.id === 'Delivered' };
          });
          setBillListMode(false);
          break;
        case 'DELAYED':
          subFilter = STATUS.map((x) => {
            return { ...x, selected: x.id === 'Delayed' };
          });
          setBillListMode(false);
          break;
        case 'COMPLETED':
          subFilter = STATUS.map((x) => {
            return { ...x, selected: x.id === 'Completed' };
          });
          setBillListMode(false);
          break;
        case 'BILL_REQUESTED':
          setBillListMode(true);
          subFilter = STATUS.map((x) => {
            return {
              ...x,
              selected: x.id === 'Bill Requested' || x.id === 'Paid',
            };
          });
          break;

        default:
          break;
      }
      updatedFilter[1].subMenu = subFilter;
      const ordersList = dashboardIrdMode ? allDashboardIRDList : allDashboardFnbList;

      const filteredItems = ordersList.filter((item) => {
        return dashboardIrdMode && currentFilterFromLocation === 'PREPARING'
          ? item?.status === 'ACCEPTED'
          : item?.status == currentFilterFromLocation;
      });
      onsetPage(0);
      setDashboardFnbOrders(
        sortList(currentFilterFromLocation !== 'TOTAL' ? filteredItems : ordersList),
      );
      setFilterDataList(updatedFilter);
    }
  }, [
    currentFilterFromLocation,
    billListMode,
    allDashboardIRDList,
    allDashboardFnbList,
    dashboardIrdMode,
  ]);

  const sortList = (data) => {
    let tempData = [...data].sort(function (a, b) {
      return b.createdAt - a.createdAt;
    });
    return tempData;
  };

  const setSearchText = (searchText) => {
    setTempSearchText(searchText);
    onsetPage(0);
    if (!searchText) {
      if (billListMode) {
        setBillsList(allDashboardBillsList);
      } else {
        setDashboardFnbOrders(filteredBaseList);
      }
      return;
    }
    if (billListMode) {
      const filteredRows = allDashboardBillsList.filter((item) => {
        return (
          item.id.split('-')[0].includes(searchText) ||
          item.guestName.toLowerCase().includes(searchText.toLowerCase()) ||
          item.tableNumber.toLowerCase().includes(searchText.toLowerCase())
        );
      });
      setBillsList(filteredRows);
    } else {
      const areaField = dashboardIrdMode ? 'roomNo' : 'tableNumber';
      const filteredRows = filteredBaseList?.filter((item) => {
        return (
          item.id.split('-')[0].includes(searchText) ||
          item.guestName.toLowerCase().includes(searchText.toLowerCase()) ||
          item[areaField].toLowerCase().includes(searchText.toLowerCase())
        );
      });
      setDashboardFnbOrders(sortList(filteredRows));
    }
  };

  const filteredRecords = (filters, field) => {
    if (field === 'all') {
      if (billListMode) {
        setBillsList(allDashboardBillsList);
        IRD_FILTER[1].subMenu = FNB_BILL_STATUS;
      } else {
        setDashboardFnbOrders(sortList(originalList));
        setFilteredBaseList(sortList(originalList));
        IRD_FILTER[1].subMenu = dashboardIrdMode ? IRD_STATUS : FNB_STATUS;
      }

      setFilterDataList(IRD_FILTER);
    } else {
      const filterIdWithFields = filterDataList
        .filter((initialFilter) => initialFilter.subMenu.length > 0)
        .map((filterItem) => {
          const subMenuFiltersId = filterItem.subMenu
            .filter((fItem) => fItem.selected === true)
            .map((fItemId) => fItemId.id);
          if (subMenuFiltersId.length > 0) {
            return {
              id: subMenuFiltersId,
              field: filterItem.field,
            };
          } else return null;
        })
        .filter((item) => item !== null);
      let filteredRecords = [];
      if (billListMode) {
        filteredRecords = allDashboardBillsList.filter((item) => {
          const doesFilterSatisfy = filterIdWithFields.map((filter) =>
            filter.id.includes(item['orderStatus']),
          );
          return !doesFilterSatisfy.includes(false);
        });
        setBillsList(filteredRecords);
      } else {
        filteredRecords = originalList.filter((item) => {
          const doesFilterSatisfy = filterIdWithFields.map((filter) =>
            filter.id.includes(item['orderStatus']),
          );
          return !doesFilterSatisfy.includes(false);
        });
        setFilteredBaseList(sortList(filteredRecords));
        setDashboardFnbOrders(sortList(filteredRecords));
      }

      onsetPage(0);
    }
  };

  const getTimeElapsed = (order) => {
    let timeDifference = 0;
    const statusToCheck = dashboardIrdMode ? 'Completed' : 'Delivered';
    if (order.orderStatus !== statusToCheck) {
      timeDifference = generatedElapsedTime(moment(), moment.unix(order?.createdAt));
      return timeDifference;
    } else {
      timeDifference = generatedElapsedTime(
        moment.unix(order?.completedTime),
        moment.unix(order?.createdAt),
      );

      return timeDifference;
    }
  };

  const handleResChange = (e) => {
    setBillListMode(false);
    onsetPage(0);
    const value = e.target.value;
    if (value && value !== 'ird') {
      dispatch(setDashBoardFnbIrdMode(false));
      dispatch(setRestaurantId(value));
      dispatch(fetchAllDashboardFnbList(selectedHotel, value));
    } else {
      dispatch(setDashBoardFnbIrdMode(true));
      dispatch(fetchAllDashboardIrdList(selectedHotel));
    }
  };

  const getBillAmount = (orders) => {
    let amount = 0;
    for (let i = 0; i < orders.length; i++) {
      for (let j = 0; j < orders[i].items.length; j++) {
        amount = amount + orders[i].items[j].amount * orders[i].items[j].count;
      }
    }
    return amount;
  };

  const isCurrentSelectedTile = (status) => {
    if (filterDataList) {
      switch (status) {
        case 'TOTAL':
          return filterDataList[1]?.subMenu?.every((v) => v.selected === false);
        case 'NEW_ORDER':
          return filterDataList[1]?.subMenu?.find((x) => x.id === 'New Order' && x.selected);
        case 'PREPARING':
          return filterDataList[1]?.subMenu?.find((x) => x.id === 'Preparing' && x.selected);
        case 'DELIVERED':
          return filterDataList[1]?.subMenu?.find((x) => x.id === 'Delivered' && x.selected);
        case 'DELAYED':
          return filterDataList[1]?.subMenu?.find((x) => x.id === 'Delayed' && x.selected);
        case 'COMPLETED':
          return filterDataList[1]?.subMenu?.find((x) => x.id === 'Completed' && x.selected);
        case 'BILL_REQUESTED':
          return filterDataList[1]?.subMenu?.find(
            (x) => (x.id === 'Bill Requested' || x.id === 'Paid') && x.selected,
          );

        default:
          break;
      }
    }
  };
  return (
    <div>
      <div className='container px-2 py-2 mw-100'>
        <div className='py-2 col'>
          <div className='col d-flex justify-content-between flex-wrap gap-2'>
            <Button
              className='py-2 dropdown-button'
              variant='outlined'
              color='secondary'
              size='medium'
            >
              <FormControl variant='standard' sx={{ mx: 1, minWidth: 240 }}>
                <Select
                  labelId='restlist-label'
                  id='rest-select-standard'
                  value={dashboardIrdMode ? 'ird' : restaurantId || ''}
                  onChange={(e) => handleResChange(e)}
                  label='Select Restaurant'
                  className='dashboard-restaurant-list-dropdown'
                >
                  {!isCulinaryOperationManager && !isFnBAgent && (
                    <MenuItem value={'ird'}>{'In-room Dining'}</MenuItem>
                  )}
                  {originalRestList?.map((spaItem) => (
                    <MenuItem key={spaItem.id} value={spaItem.id}>
                      {spaItem.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Button>
            {!isFnBAgent && (
              <Button
                className='py-2'
                variant='outlined'
                color='secondary'
                size='medium'
                endIcon={<ArrowRightIcon />}
                onClick={() =>
                  history.push(dashboardIrdMode ? '/in-room-dining' : '/restaurant?tab=INFO')
                }
              >
                {'View Menu'}
              </Button>
            )}
          </div>
        </div>
        {(dashboardIrdMode ? dashboardIrdCount : dashboardFnbCount)?.length > 0 && (
          <div>
            <div className='py-2 d-flex flex-wrap gap-3'>
              {(dashboardIrdMode ? dashboardIrdCount : dashboardFnbCount)?.map(
                (currentCount, countNdx) => (
                  <CustomCountBox count={currentCount} key={countNdx} className={'col'} />
                ),
              )}
            </div>
          </div>
        )}
        <div className='dashboard-ird-list'>
          <div className='card shadow'>
            <div className='py-3 group-list-container'>
              <SearchBar
                displayAddOrEdit='hide'
                setSearchText={setSearchText}
                filterList={filterDataList}
                setFilterDataList={setFilterDataList}
                filteredRecoard={filteredRecords}
                searchText={tempSearchText}
                setSearch={setTempSearchText}
                actionMenuItems={[]}
              />
              <div className='px-3 py-2'>
                {loading ? (
                  <div className='pt-2 col'>
                    <LinearProgressBar />
                  </div>
                ) : !billListMode ? (
                  dashboardFnbOrders && (
                    <TableContainer>
                      <Table className='list-table' aria-label='simple table'>
                        <TableHead>
                          <TableRow className='border-white pointer'>
                            <TableCell className='w-10'>Order Id</TableCell>
                            <TableCell align='center' className='w-15'>
                              {dashboardIrdMode ? 'Room No' : 'Table No'}
                            </TableCell>
                            <TableCell className='w-25'>Guest name</TableCell>
                            <TableCell className='w-20 ps-4'>Time elapsed</TableCell>
                            <TableCell align='center' className='w-15 ps-5'>
                              No.of Items
                            </TableCell>
                            <TableCell className='w-15 ps-4' align='center'>
                              Channel Type
                            </TableCell>
                            <TableCell className='w-15 ps-5 pe-4' align='center'>
                              Status
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {(rowsPerPage > 0
                            ? dashboardFnbOrders.slice(
                                page * rowsPerPage,
                                page * rowsPerPage + rowsPerPage,
                              )
                            : dashboardFnbOrders
                          ).map((item, i) => (
                            <TableRow
                              key={i}
                              className='border-white pointer'
                              onClick={(e) => {
                                onViewDetails(DASHBOARD_IRD_VIEW, item, e);
                              }}
                            >
                              <TableCell>{item.id.split('-')[0]}</TableCell>
                              <TableCell align='center'>
                                {dashboardIrdMode ? item.roomNo : item.tableNumber}
                              </TableCell>
                              <TableCell className='ps-4'>{item.guestName}</TableCell>
                              <TableCell className='ps-4'>{getTimeElapsed(item)}</TableCell>
                              <TableCell align='center' className='ps-5'>
                                {item.items.length > 0
                                  ? item.items.length > 10
                                    ? item.items.length
                                    : `0${item.items.length}`
                                  : 'NA'}
                              </TableCell>
                              <TableCell align='center' className='ps-4'>
                                {item.channelType || '---'}
                              </TableCell>
                              <TableCell className='ps-5'>
                                <div className='d-flex align-content-center ps-2'>
                                  <div
                                    className={
                                      item.statusClass +
                                      ' pill d-flex justify-content-center align-items-center py-2 w-90'
                                    }
                                  >
                                    <span className='ms-1'>{item.orderStatus ?? 'NA'}</span>
                                  </div>
                                </div>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                        <TableFooter>
                          <TableRow className='paginator'>
                            <TablePagination
                              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                              count={dashboardFnbOrders.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              SelectProps={{
                                inputProps: { 'aria-label': 'rows per page' },
                                native: true,
                              }}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                              ActionsComponent={TablePaginationActions}
                            />
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </TableContainer>
                  )
                ) : (
                  <TableContainer>
                    <Table className='list-table' aria-label='simple table'>
                      <TableHead>
                        <TableRow className='border-white pointer'>
                          <TableCell className='w-15'>Order Id</TableCell>
                          <TableCell align='center' className='w-15'>
                            {'Table No'}
                          </TableCell>
                          <TableCell className='w-25'>Guest name</TableCell>
                          <TableCell className='w-20 ps-4'>Time elapsed</TableCell>
                          <TableCell align='center' className='w-15 ps-5'>
                            Bill Amount
                          </TableCell>
                          <TableCell className='w-15 ps-5 pe-4' align='center'>
                            Status
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {(rowsPerPage > 0
                          ? billsList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                          : billsList
                        ).map((item, i) => (
                          <TableRow
                            key={i}
                            className='border-white pointer'
                            onClick={(e) => {
                              onViewDetails(DASHBOARD_BILL_VIEW, item, e);
                            }}
                          >
                            <TableCell>{item.id.split('-')[0]}</TableCell>
                            <TableCell align='center'>{item.tableNumber}</TableCell>
                            <TableCell className='ps-4'>{item.guestName}</TableCell>
                            <TableCell className='ps-4'>{getTimeElapsed(item)}</TableCell>
                            <TableCell align='center' className='ps-5'>
                              {currency} {getBillAmount(item?.orders)}
                            </TableCell>
                            <TableCell className='ps-5'>
                              <div className='d-flex align-content-center ps-2'>
                                <div
                                  className={
                                    item.statusClass +
                                    ' pill d-flex justify-content-center align-items-center py-2 w-90'
                                  }
                                >
                                  <span className='ms-1'>{item.orderStatus ?? 'NA'}</span>
                                </div>
                              </div>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                      <TableFooter>
                        <TableRow className='paginator'>
                          <TablePagination
                            rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                            count={billsList.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            SelectProps={{
                              inputProps: { 'aria-label': 'rows per page' },
                              native: true,
                            }}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            ActionsComponent={TablePaginationActions}
                          />
                        </TableRow>
                      </TableFooter>
                    </Table>
                  </TableContainer>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardFnbList;
